<template>
	<AspectTable />
</template>

<script>
import AspectTable from "@/components/AspectTable/AspectTable";

export default {
	name: "AspectPage",
	components: {
		AspectTable
	}
}
</script>

<style scoped>

</style>